"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Strings_1 = require("../Utility/Strings");
class UrlBuilder {
    constructor(url) {
        this.url = url;
        this.propTrimOptional = false;
    }
    replaceVars(replaceVars) {
        this.propReplaceVars = replaceVars;
        return this;
    }
    /**
     * Replace optional parameters at the end of a url.
     * @see Symfony documentation: https://symfony.com/doc/current/routing.html#optional-parameters
     */
    trimOptional() {
        this.propTrimOptional = true;
        return this;
    }
    build() {
        let url = this.url;
        // replace any variables in the url
        if (this.propReplaceVars) {
            for (const [key, replacement] of Object.entries(this.propReplaceVars)) {
                url = url.replace(`[{${key}}]`, Strings_1.default.coalesce(replacement, '')).replace(`{${key}}`, Strings_1.default.coalesce(replacement, ''));
            }
        }
        if (this.propTrimOptional) {
            // replace all trailing occurrences of `/[{_abc-def}]`
            // remove all trailing `/`, up to 10 due to denial service attacks.
            url = url.replace(/(\/\[{[a-zA-Z0-9-_]+}])+$/, '').replace(/\/{1,10}$/, '');
        }
        return url;
    }
}
exports.default = UrlBuilder;
//# sourceMappingURL=UrlBuilder.js.map